import Immutable from 'seamless-immutable';
import { SET_SELECTED_CASE_DETAIL_TAB_INDEX } from './actions/customer.case.details.actions';
import { CASE_DETAILS_TABS } from '../components/customer/cases/list/case.constants';
export var INITIAL_STATE = Immutable({
  selectedCaseDetailTabIndex: CASE_DETAILS_TABS.DETAILS
});
export default function caseDetailsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SET_SELECTED_CASE_DETAIL_TAB_INDEX:
      return state.set('selectedCaseDetailTabIndex', payload);
    default:
      return state;
  }
}